import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusbarComponent } from './statusbar.component';
import { ProgressBarModule } from '@syncfusion/ej2-angular-progressbar';


@NgModule({
  declarations: [
    StatusbarComponent
  ],
  imports: [
    CommonModule,
    ProgressBarModule,
  ],
  exports: [
    StatusbarComponent
  ]
})
export class StatusbarModule { }
